
  (function () {
    function applySalepifyOverride() {
      if (!window.tlCartGoalEmbed) {
        setTimeout(applySalepifyOverride, 300);
        return;
      }

      const originalRender = window.tlCartGoalEmbed.renderCartGoalToElements;

      window.tlCartGoalEmbed.renderCartGoalToElements = function (config, index) {
        if (!config || !config.selector) return;

        document.querySelectorAll(config.selector).forEach((el) => {
          const oldContainer = el.parentNode?.querySelector('.tl__cart-goal__container__drawer');
          if (oldContainer) oldContainer.remove();

          const container = document.createElement('div');
          container.className = 'tl__cart-goal__container__drawer';
          container.innerHTML = this.renderCartGoal(index);

          const target = document.querySelector('.drawer__cart-items-wrapper'); 

          if (target) {
            target.insertAdjacentElement('beforebegin', container);
          } else {
            el.insertAdjacentElement('beforebegin', container); 
          }
        });
      };

      if (typeof window.tlCartGoalEmbed.renderAllCartGoals === 'function') {
        window.tlCartGoalEmbed.renderAllCartGoals();
      }
    }

    applySalepifyOverride();
  })();
